import { types } from "../Actions/types";

const initialState = {
  exerciselist: [],
  error: null,
  exerciseSingle: "",
  popupmodel: "",
};

const Exercise = (state = initialState, action) => {
  let { type, payload, error } = action;
  if (payload && payload.error !== null) {
    error = payload.error;
  }

  switch (type) {
    case types.EXERCISE_LIST:
      return {
        ...state,
        exerciselist: payload,
        error,
      };
    case types.EXERCISE_SINGLE:
      return {
        ...state,
        exerciseSingle: payload,
        error,
      };
    case types.EXERCISE_FORM_MODEL:
      return {
        ...state,
        popupmodel: payload,
      };

    default:
      return state;
  }
};

export default Exercise;
